export default "__VITE_ASSET__B8jV30TT__"